module.exports = __webpack_public_path__ + "sunsemweb/img/bg.e56b0d17.jpg";